import React from "react";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-center">
        <div className="loading1 loading"></div>
        <div className="loading2 loading"></div>
        <div className="loading3 loading"></div>
      </div>
    </div>
  );
};

export default Loading;
